<template>
    <modal modalClasses="modal_full_ancho" :show.sync="showModal" size="sm">
        <h6 slot="header" class="modal-title">Ingresar firma</h6>
        <VueSignaturePad
            v-if="showModal"
            id="idSignature"
            width="100%"
            height="300px"
            ref="signaturePad"
            :options="options"
          />
        <template slot="footer">
            <base-button type="primary" nativeType="button" @click="obtenerImagen"  >Ok</base-button>
            <base-button type="link" class="ml-auto" @click="showModal = false">Cancelar</base-button>
        </template>
    </modal>
</template>

<script>
export default {
    data(){
        return {
            options: {
                penColor: "#000"
            },
            showModal: false,
            id: undefined
        }
    },
    methods: {
        inicializarPad(venta_id){
            this.showModal = true;
            this.$nextTick( () => {
                this.$refs.signaturePad.clearSignature();
            } );
            this.id = venta_id;
        },
        obtenerImagen(){
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
            console.log(data);
            var vm = this;
            this.axios({
                url: 'api/ventas/attach_signature',
                method: 'POST',
                data: {
                    firma: data,
                    venta_id: this.id
                }
            }).then( response => {
                
                vm.$notify({
                    type: 'success',
                    message: 'Firma agregada correctamente!'
                });
                vm.showModal = false;
                vm.$emit('firmaSuccess');
            }).catch( error => {
                console.log(error);
                vm.showModal = false;
            });
            
            
        }
    },
    created()
    {
      this.$parent.$on('loadModalFirma', (venta_id) => { this.inicializarPad(venta_id); } );
    },
}
</script>
<style lang="scss">
.modal_full_ancho {
    width: 100%;
    max-width: 100%;
}
#idSignature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}
</style>